import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ExcelDownload from "../../components/Utils/excelDownload";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFilterModal from "../../components/Common/CommonFilterModal";
import FilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import NavBarTitles from "../../components/Common/TabBar";
import { preferredDay, specialisationNew } from "../../components/Constants";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import SucessModal from "../../components/Modal/SucessModal";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";
import {
  BookDemo,
  BookDemocolumnOrder,
  DoctorDemoTable,
  HealthSynergynavBarData,
} from "./HealthSynergyConst";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";

const DoctorDemo = () => {
  const [filtered_records, setFilteredRecords] = useState([]);
  const limit = 10;
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");

  const specialisationdata = [];
  const daydata = [];
  const [submitfilter] = useState(false);

  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [del, setDel] = useState(false);
  const [id, setId] = useState("");
  const [search, setSearch] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Specialisation");
  const [selectedValues, setSelectedValues] = useState({
    Specialisation: [],
    "Preferred Day": [],
  });
  const [filters, setFilters] = useState({
    Specialisation: specialisationNew,
    "Preferred Day": preferredDay,
  });
  const [loader, setLoader] = useState(true);

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}doctor-book-a-demo/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
    setSortName(
      {
        newest: "Newest First",
        oldest: "Oldest First",
        ascending: "Alphabetic A-Z",
        descending: "Alphabetic Z-A",
      }[selectedSort] || "Sort by",
    );
  };
  const filterRecordsFromSelected = () => {
    let filtered = [...records];

    const specialisationFilters = selectedValues["Specialisation"];
    const preferredDayFilters = selectedValues["Preferred Day"];

    // Specialisation filter
    if (specialisationFilters?.length > 0) {
      filtered = filtered.filter((item) =>
        specialisationFilters.includes(item.specialization),
      );
    }

    // Preferred Day filter
    if (preferredDayFilters?.length > 0) {
      filtered = filtered.filter((item) =>
        preferredDayFilters.some((day) => item.preferred_days?.includes(day)),
      );
    }

    setFilteredRecords(filtered);
  };

  useEffect(() => {
    if (
      selectedValues["Specialisation"].length > 0 ||
      selectedValues["Preferred Day"].length > 0
    ) {
      filterRecordsFromSelected();
    }
  }, [records]);

  useEffect(() => {
    !assignModal.status && !leadStatusModal.status && setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    success,
    leadStatussuccess,
  ]);

  useEffect(() => {
    (async () => {
      const specialisationResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}specialization/getarray`,
      );
      if (specialisationResponse?.data) {
        await setFilters({
          Specialisation: specialisationResponse.data,
          "Preferred Day": filters["Preferred Day"],
        });
      }
    })();
  }, []);

  const handleDelete = useDeleteHandler(
    "doctor-book-a-demo",
    fetchData,
    setDel,
  );

  //Contact Functionality
  const handleContact = (id) => {
    setLoader(true);
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}doctor-book-a-demo/update/${id}`,
        {
          contact: true,
          notContacted: false,
          onBoard: false,
        },
      )
      .then((result) => {
        fetchData();
      });
  };

  //NotContact Functionality
  const handleNotContact = (id) => {
    setLoader(true);
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}doctor-book-a-demo/update/${id}`,
        {
          contact: false,
          notContacted: true,
          onBoard: false,
        },
      )
      .then((result) => {
        fetchData();
      });
  };

  //On-Board Functionality
  const handleOnBoard = (id) => {
    setLoader(true);
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}doctor-book-a-demo/update/${id}`,
        {
          contact: false,
          notContacted: false,
          onBoard: true,
        },
      )
      .then((result) => {
        fetchData();
      });
  };

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    fetchData();
  };

  const handlePageChange = usePageChange(pagination, setPagination);

  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  const onClickDownload = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}doctor-book-a-demo/list`,
        {
          skip: 0,
          limit: 3000,
          searchText: search,
          values: {
            specialization: specialisationdata,
            day: daydata,
          },
          sort: sort,
        },
      );
      if (!response?.data?.rows?.length) {
        throw new Error("No records available to download.");
      }
      const records = response.data.rows;
      const formattedRecords = records.map((record, index) => ({
        "S.No": index + 1,
        "Time of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleTimeString()
          : "",
        "Date of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleDateString()
          : "",
        Name: record.name || "",
        Email: record.email || "",
        "Mobile Number": record.mobile || "",
        Specialisation: record.specialization || "",
        "Preferred Contact Time": record.time || "",
        "Registration Date and Time": record.day || "",
        "Assigned To": record.assigned_to || "",
        "Lead Status": record.lead_status || "",
        // Actions: "",
      }));

      ExcelDownload(
        formattedRecords,
        BookDemocolumnOrder,
        "doctor-book-a-demo.xlsx",
      );
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message,
      );
      // console.error("Error downloading the file:", err.message);
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={BookDemo}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total : {totalCount}
            </div>
            {totalCount > pagination.limit && (
              <Pagination
                skip={pagination.skip}
                limit={limit}
                total={totalCount}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={HealthSynergynavBarData} />
          <FilterOptions
            limit={pagination.limit}
            // sortshow={sortshow}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            // setSortShow={setSortShow}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={true}
            onClickDownload={() => setIsModalOpen(true)}
            handleSortClick={handleSortClick}
          />
          <DoctorDemoTable
            filtered_records={filtered_records}
            records={records}
            skip={pagination.skip}
            setAssignModal={setAssignModal}
            setLeadStatusModal={setLeadStatusModal}
            setId={setId}
            setDel={setDel}
            handleContact={handleContact}
            handleNotContact={handleNotContact}
            handleOnBoard={handleOnBoard}
            loader={loader}
          />
        </div>
      </MainconternLayout>
      {del === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={id}
          handleClose={() => setDel(false)}
        />
      )}

      {/*---------Filter Portion--------*/}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(filters)[0]); // Reset to first category
        }}
        onApply={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(filters)[0]); // Reset to first category
          filterRecordsFromSelected();
          fetchData();
        }}
        onReset={() => {
          setSelectedValues({
            Specialisation: [],
            "Preferred Day": [],
          });
          setFilteredRecords([]);
          setSelectedCategory(Object.keys(filters)[0]); // Reset on reset too (optional)
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        // searchOnlyCategories={["City / Town"]}
      />

      {assignModal.status === true && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
          pathName="doctor-demo"
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          onClick={() => successModalClose()}
          page="/doctor-demo"
        />
      )}

      {leadStatusModal.status === true && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
        />
      )}

      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={() => successModalClose()}
          page="/doctor-demo"
        />
      )}
      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default DoctorDemo;
